module.exports = __webpack_public_path__ + "img/1570046321.32cbc6ef.jpg";